import { render } from "./AproposDesktop.vue?vue&type=template&id=67c908bc&scoped=true"
import script from "./AproposDesktop.vue?vue&type=script&lang=js"
export * from "./AproposDesktop.vue?vue&type=script&lang=js"

import "./AproposDesktop.vue?vue&type=style&index=0&id=67c908bc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67c908bc"]])

export default __exports__